/**
 * Аутентификация держится на HttpOnly-cookie: браузер отправляет её сам,
 * JavaScript значение токена не получает, не читает и не хранит.
 * Живость сессии проверяется запросом "GET /lk-api/allowed-pages".
 */

import store from "@/store/";
import { Route } from "vue-router";

export const ifNotAuthenticated = (to: Route, from: Route, next: any): any => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

export const ifAuthenticated = async (to: Route, from: Route, next: any): Promise<any> => {
  // После перезагрузки страницы состояние в памяти пустое, а cookie может быть жива.
  // Узнать это можно только у бэкенда — в localStorage признака сессии больше нет.
  if (!store.getters.isAuthenticated && !(await validateSession())) {
    next("/login");
    return;
  }

  const allowedPages: string[] = JSON.parse(localStorage.getItem("lk-allowedPages") || "[]");

  if (allowedPages.length > 0) {
    if (to.path !== "/change_password" && store.getters.isNeedChangePassword === true) {
      next("/change_password");
    }
    if (to.meta.msgKey && !allowedPages.includes(to.meta.msgKey)) {
      next("/access_denied")
    }
    next();
  } else {
    next("/login");
  }
};

/** Успешный ответ означает, что cookie принята бэкендом. Токен при этом не читается. */
async function validateSession(): Promise<boolean> {
  try {
    const allowedPages = await store.dispatch("getAllowedPages");
    localStorage.setItem("lk-allowedPages", JSON.stringify(allowedPages));

    store.commit('authSuccess');
    return true;
  } catch (error) {
    return false;
  }
}
